<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="prompt"
      v-bind:title="lang('lbl_0000113')"
      v-bind:message="lang('lbl_0000122')"
    />
    <ModalControl
      @closed="modalClosed"
      v-bind:show="modal"
      v-bind:title="lang('lbl_0000155')"
      dismiss
    >
      <div v-if="this.code == 'GA00000001'">
        <div class="mb-4">
          <div
            v-text="lang('lbl_0000156')"
            class="font-bold text-sm leading-normal"
          ></div>
          <div class="pt-2">
            <div class="flex leading-normal">
              <div
                v-text="formatDate($store.state.ga.registration.start_date)"
                class="flex-1 p-1 rounded text-sm truncate text-white bg-theme-elecom"
              ></div>
              <div
                v-text="lang('lbl_0000157')"
                class="px-2 text-sm flex items-center justify-center text-grey-darkest"
              ></div>
              <div
                v-text="formatDate($store.state.ga.registration.end_date)"
                class="flex-1 p-1 rounded text-sm truncate text-white bg-theme-elecom"
              ></div>
            </div>
          </div>
        </div>
        <div class="mb-4 border-t">
          <div
            v-text="lang('lbl_0000163')"
            class="font-bold text-sm leading-normal pt-2"
          ></div>
          <div class="pt-2">
            <div class="flex leading-normal">
              <div
                v-text="formatDate($store.state.ga.voting.start_date)"
                class="flex-1 p-1 rounded text-sm truncate text-white bg-theme-elecom"
              ></div>
              <div
                v-text="lang('lbl_0000157')"
                class="px-2 text-sm flex items-center justify-center text-grey-darkest"
              ></div>
              <div
                v-text="formatDate($store.state.ga.voting.end_date)"
                class="flex-1 p-1 rounded text-sm truncate text-white bg-theme-elecom"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="this.code == 'GA00000002'">
        <div>
          <div class="pt-2 pb-2">
            <div class="flex flex-col leading-normal">
              <div class="flex flex-col p-4 rounded text-sm bg-grey-lighter">
                <span class="font-semibold mb-1">{{
                  lang("lbl_0000215")
                }}</span>
                <span>{{
                  formatSchedule(this.$store.state.sga.schedules.start_date)
                }}</span>
              </div>
              <div
                class="flex flex-col p-4 rounded text-sm bg-grey-lighter mt-4"
              >
                <span class="font-semibold mb-1">{{
                  lang("lbl_0000216")
                }}</span>
                <span>{{
                  formatSchedule(this.$store.state.sga.schedules.end_date)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalControl>
    <ContentWrapperControl class="mt-4">
      <SliderControl :slides="getSlides"></SliderControl>
    </ContentWrapperControl>
    <ContentWrapperControl class="mt-4" v-if="this.code == 'GA00000002'">
      <div class="rounded-t shadow overflow-hidden">
        <!-- <img v-bind:src="image" class="w-full border-0 m-0 p-0 block" /> -->
        <img
          v-bind:src="getSGABanner()"
          class="w-full border-0 m-0 p-0 block"
        />
      </div>
      <div
        class="bg-white border-b border-grey shadow rounded-b overflow-hidden"
      >
        <div v-show="loading">
          <!-- <img v-bind:src="getLoader()" class="block mx-auto" /> -->
          <img
            class="block mx-auto my-4 h-spinner w-spinner"
            src="@/assets/icons/papsi_spinner.svg"
            alt="Loading..."
          />
        </div>
        <div v-if="!this.loading">
          <div class="px-4 pt-2">
            <div
              class="pb-4"
              v-if="
                !this.sga.schedules.has_ended && this.sga.schedules.has_started
              "
            >
              <div
                class="flex flex-row justify-between font-bold text-sm items-center py-2"
              >
                <span v-text="lang('lbl_0000120')"></span>
                <img
                  class="w-icon h-icon"
                  v-on:click="modalOpen"
                  v-bind:src="require('@/assets/icons/papsi_calendar.svg')"
                />
              </div>
              <SpecialCountdownControl :date="this.sga.schedules.end_date" />
            </div>
            <div
              class="pb-4"
              v-if="
                !this.sga.schedules.has_started && !this.sga.schedules.has_ended
              "
            >
              <div
                class="flex flex-row justify-between font-bold text-sm items-center py-2"
              >
                <span v-text="lang('lbl_0000119')"></span>
                <img
                  class="w-icon h-icon"
                  v-on:click="modalOpen"
                  v-bind:src="require('@/assets/icons/papsi_calendar.svg')"
                />
              </div>
              <SpecialCountdownControl :date="this.sga.schedules.start_date" />
            </div>
            <div
              class="pb-4"
              v-show="
                !this.sga.user.has_participated &&
                this.sga.schedules.has_started &&
                !this.sga.schedules.has_ended &&
                this.sga.user.can_participate
              "
            >
              <ButtonControl @click="this.$router.push('/sga/referendum')">{{
                lang("lbl_0000121")
              }}</ButtonControl>
            </div>
            <div
              class="pb-4"
              v-show="
                !this.loading &&
                !this.sga.user.can_participate &&
                this.$store.state.info.regular &&
                !this.sga.user.has_registered &&
                !this.sga.schedules.has_ended &&
                this.sga.schedules.has_started
              "
            >
              <ButtonControl @click="registerSGA">{{
                lang("lbl_0000113")
              }}</ButtonControl>
            </div>
          </div>
        </div>
        <div
          v-show="
            !this.loading &&
            this.sga.user.has_participated &&
            !this.sga.schedules.has_ended &&
            this.sga.schedules.has_started
          "
          v-text="lang('lbl_0000164')"
          class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
        ></div>
        <div
          v-show="
            !this.loading &&
            !this.sga.user.can_participate &&
            this.$store.state.info.regular &&
            this.sga.user.has_registered &&
            !this.sga.schedules.has_ended &&
            this.sga.schedules.has_started
          "
          v-text="lang('lbl_0000162')"
          class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
        ></div>
        <div
          v-show="
            !this.loading &&
            !this.sga.user.can_participate &&
            !this.$store.state.info.regular &&
            !this.sga.schedules.has_ended
          "
          v-text="lang('lbl_0000250')"
          class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
        ></div>
        <div
          v-show="!this.loading && this.sga.schedules.has_ended"
          v-text="lang('lbl_0000213')"
          class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
        ></div>
      </div>
    </ContentWrapperControl>
    <ContentWrapperControl v-if="this.code == 'GA00000001'" class="mt-4">
      <div class="rounded-t shadow overflow-hidden">
        <img v-bind:src="image" class="w-full border-0 m-0 p-0 block" />
      </div>
      <div
        class="bg-white border-b border-grey shadow rounded-b overflow-hidden"
      >
        <div v-show="loading">
          <img v-bind:src="getLoader()" class="block mx-auto" />
        </div>
        <div v-if="!loading && !voting_ended" class="flex px-4 pt-2">
          <div
            class="font-bold text-sm leading-normal flex-grow flex items-center py-1"
          >
            <span v-text="message"></span>
          </div>
          <div v-if="false" class="w-icon">
            <img
              v-on:click="modalOpen"
              v-bind:src="require('@/assets/icons/papsi_calendar.svg')"
            />
          </div>
        </div>
        <div
          v-if="!loading && voting_ended"
          v-text="lang('lbl_0000112')"
          class="py-4 text-center text-grey-dark text-sm leading-normal"
        ></div>
        <div v-if="!loading && !voting_ended">
          <div>
            <div class="px-4 py-2">
              <CountdownControl @ticking="ticking" @ended="electionEnds" />
            </div>
          </div>
          <div v-show="isButtonVisible()" class="px-4 pb-4">
            <ButtonControl v-on:click="openPrompt">
              {{ getButtonLabel() }}
            </ButtonControl>
          </div>
          <div
            v-show="
              !voting_ended &&
              registration_started &&
              !voting_started &&
              registered
            "
            v-text="lang('lbl_0000162')"
            class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
          ></div>
          <div
            v-show="!voting_ended && voting_started && voted"
            v-text="lang('lbl_0000164')"
            class="px-4 pb-4 text-center text-sm border-t pt-4 text-grey-dark"
          ></div>
        </div>
      </div>
    </ContentWrapperControl>
    <ModalControl
      @closed="show_rating = false"
      :dismiss="true"
      :show="show_rating"
      :title="lang('lbl_0000226')"
    >
      <div class="flex flex-col">
        <span class="mt-2">{{ lang("lbl_0000218") }}</span>
        <div class="flex flex-col items-center mt-4">
          <SpecialRatingControl v-bind:submit="submit_rating" :type="1" />
        </div>
        <div class="flex flex-row mt-4">
          <ButtonControl
            :theme="'error'"
            @click="
              show_rating = false;
              this.$router.push({ name: 'dashboard-page' });
            "
            class="mr-4"
          >
            {{ lang("lbl_0000199") }}
          </ButtonControl>
          <ButtonControl @click="submitRating()">
            {{ lang("lbl_0000190") }}
          </ButtonControl>
        </div>
      </div>
    </ModalControl>
    <ModalControl
      @closed="show_success = false"
      :dismiss="false"
      :show="show_success"
      :title="lang('lbl_0000225')"
      theme="success"
    >
      <div>
        <img
          src="@/assets/icons/papsi_check_circle.svg"
          class="block mx-auto mt-2 h-modal-icon w-modal-icon"
        />
        <div
          v-text="lang('lbl_0000290')"
          class="text-sm text-center pt-5 pb-5 font-semibold"
        ></div>
        <ButtonControl
          @click="
            show_rating = true;
            show_success = false;
          "
        >
          {{ lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </ModalControl>
  </div>
</template>

<script>
import datetime from "date-and-time";
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import SpecialCountdownControl from "@/components/controls/SpecialCountdownControl.vue";
import SpecialRatingControl from "@/components/controls/SpecialRatingControl.vue";
import CountdownControl from "./../components/controls/CountdownControl.vue";
import SliderControl from "@/components/controls/SliderControl.vue";
import ButtonControl from "./../components/controls/ButtonControl.vue";
import PromptControl from "./../components/controls/PromptControl.vue";
import ModalControl from "./../components/controls/ModalControl.vue";
import FunRun from "@/services/FunRun";
import GA from "../services/GA.js";
import mixin from "./../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    CountdownControl,
    SpecialCountdownControl,
    ModalControl,
    PromptControl,
    SpecialRatingControl,
    SliderControl,
  },
  data() {
    return {
      image: "",
      loading: true,
      registration_started: false,
      voting_started: false,
      voting_ended: false,
      title: null,
      message: "",
      voted: false,
      registered: false,
      can_vote: false,
      prompt: false,
      modal: false,
      show_rating: false,
      submit_rating: false,
      show_success: false,
      code: null,
      sga: {
        date: null,
        title: null,
        user: {
          uuid: null,
          can_participate: false,
          has_participated: false,
        },
        schedules: {
          has_started: false,
          has_ended: false,
          start_date: null,
          end_date: null,
        },
      },
      fun_run: {
        run_key: null,
        run_year: null,
        event_name: null,
        event_date: null,
        event_location: null,
        has_started: false,
        has_ended: false,
        registration_start: null,
        registration_end: null,
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      type: "primary",
    });

    this.image = this.getMediaPath("/ad/ga25_banner_sm.jpg");

    let state = this.$store.state;

    if (
      (!state.info.tin || !state.info.date_of_birth) &&
      this.$cookies.get("skipped_update") !== state.hash
    ) {
      this.makeSkipCookie(state.hash);
      this.$router.push("/user/info/checklist/optional");
      return;
    }

    if (!state.deactivated && state.has_pin && this.code == "GA00000002") {
      this.loadInfo();
      return;
    }

    this.loadFunRun();
  },
  computed: {
    getSlides() {
      return [
        {
          background_image: this.getFunRunBanner(),
          title: "",
          subtitle: "",
          button_text: this.lang("lbl_0000315"),
          button_link: "/events",
          button_disabled: !this.fun_run.has_started || this.fun_run.has_ended,
          button_style: "secondary",
        },
        {
          background_image: this.getEFTBG(),
          title: this.lang("lbl_0000297"),
          subtitle: "",
          button_text: this.lang("lbl_0000309"),
          button_link: "/services/eft",
          button_disabled: false,
          button_style: "primary",
        },
      ];
    },
  },
  methods: {
    getSGABanner() {
      const file_name = "new_banner_placeholder.png";
      const path = "referendum/";
      return this.getAsset(path, file_name);
    },
    getFunRunBG() {
      const path = "funrun/";
      const file_name = "papsi_fun_run.jpg";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    getEFTBG() {
      const path = "eft/";
      const file_name = "papsi_eft_banner.jpg";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    getFunRunBanner() {
      const path = "funrun/";
      const file_name = "papsi_run_mobile.jpg";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    tick(start, end) {
      const now = new Date().getTime();
      const start_time = new Date(start).getTime();
      const end_time = new Date(end).getTime();
      const store_fun_run = this.$store.state.fun_run;
      const local_fun_run = this.fun_run;

      if (now >= end_time) {
        store_fun_run.has_started = true;
        store_fun_run.has_ended = true;
        local_fun_run.has_started = true;
        local_fun_run.has_ended = true;
        return;
      } else if (now >= start_time && now < end_time) {
        store_fun_run.has_started = true;
        store_fun_run.has_ended = false;
        local_fun_run.has_started = true;
        local_fun_run.has_ended = false;
      } else {
        store_fun_run.has_started = false;
        store_fun_run.has_ended = false;
        local_fun_run.has_started = false;
        local_fun_run.has_ended = false;
      }

      setTimeout(() => this.tick(start, end), 1000);
    },
    isButtonVisible() {
      return (
        !this.voting_ended &&
        ((this.voting_started && !this.voted && this.can_vote) ||
          (this.registration_started && !this.registered))
      );
    },
    loadFunRun() {
      this.$emit("showloader");
      FunRun.getSchedule()
        .then((response) => {
          const data = response.data.data;

          if (!Array.isArray(data) || data.length === 0) {
            console.warn("No schedule data found");
            return;
          }

          const event = data[0];
          const state = this.$store.state.fun_run;
          state.run_key = event.run_key;
          state.run_year = event.run_year;
          state.event_name = event.event_name;
          state.event_date = event.event_date;
          state.event_location = event.event_location;
          state.has_started = event.has_started;
          state.has_ended = event.has_ended;
          state.registration_start = event.registration_start;
          state.registration_end = event.registration_end;

          this.fun_run = { ...state };
          this.tick(state.registration_start, state.registration_end);
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    loadInfo() {
      GA.special()
        .then((response) => {
          let data = response.data.data,
            state = this.$store.state.sga;
          state.code = data.code;
          state.date = data.date;
          state.title = data.title;
          state.user.uuid = data.user.uuid;
          state.user.can_participate = data.user.can_participate;
          state.user.has_participated = data.user.has_participated;
          state.schedules.has_started = data.schedules.has_started;
          state.schedules.has_ended = data.schedules.has_ended;
          state.schedules.start_date = data.schedules.start_date;
          state.schedules.end_date = data.schedules.end_date;

          this.code = data.code;
          this.sga.title = data.title;
          this.sga.date = data.date;
          this.sga.user.uuid = data.user.uuid;
          this.sga.user.can_participate = data.user.can_participate;
          this.sga.user.has_participated = data.user.has_participated;
          this.sga.user.has_registered = data.user.has_registered;
          this.sga.schedules.has_started = data.schedules.has_started;
          this.sga.schedules.has_ended = data.schedules.has_ended;
          this.sga.schedules.start_date = data.schedules.start_date;
          this.sga.schedules.end_date = data.schedules.end_date;
          // this.tick();
          this.tick(this.sga.schedules.start_date, this.sga.schedules.end_date);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },
    ticking(message) {
      let state = this.$store.state;

      this.registration_started = state.ga.registration.started;
      this.voting_started = state.ga.voting.started;
      this.voting_ended = state.ga.voting.ended;
      this.message = message;
    },
    electionEnds() {
      this.voting_ended = true;
    },
    getLoader() {
      return process.env.VUE_APP_MEDIA_URL + "images/loader/gear-spinner.gif";
    },
    getButtonLabel() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        return this.lang("lbl_0000121");
      } else {
        return this.lang("lbl_0000113");
      }
    },
    openPrompt() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        this.$router.push("/ga/election/auth");
      } else {
        this.prompt = true;
      }
    },
    ok() {
      let state = this.$store.state;

      if (this.voting_started && !state.ga.voted && state.ga.registered) {
        this.vote();
      } else {
        this.register();
      }
    },
    cancel() {
      this.prompt = false;
    },
    closed() {
      this.prompt = false;
    },
    register() {
      let that = this,
        state = this.$store.state;

      this.$emit("showloader");
      GA.register(state.ga.code)
        .then(function (response) {
          state.ga.registered = true;
          that.registered = true;
          that.$emit("success", response.data.data.message);
        })
        .catch(function (error) {
          that.$emit("error", error);
        });
    },
    vote() {
      this.$router.push("/ga/vote");
    },
    modalOpen() {
      this.modal = true;
    },
    modalClosed() {
      this.modal = false;
    },
    formatDate(date) {
      return datetime.format(new Date(date), "MM/DD/YYYY hh:mm A");
    },
    formatSchedule(date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      };

      return new Date(date).toLocaleString("en-US", options);
    },
    registerSGA() {
      let state = this.$store.state;

      this.$emit("showloader");
      GA.register(this.code, state.hash, state.key)
        .then(() => {
          // state.sga.user.has_registered = true;
          this.sga.user.has_registered = true;
          this.show_success = true;
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    submitRating() {
      this.submit_rating = true;
      this.show_rating = false;
    },
  },
};
</script>

<style scoped>
.papsi-status-dim {
  width: 10px;
  height: 10px;
}
</style>
